import { createEvent } from '@cobuildlab/react-simple-state';
import { BreabrumbLink } from './breabcrumb-type';

export const OnBreabcrumbText = createEvent<BreabrumbLink[] | undefined>();
export const OnBreabcrumbTextError = createEvent<Error>();
